module.exports = __webpack_public_path__ + "img/service21.3957c969.png";